@if (error) {
  <info [option]="optionInfo1">
    {{ error.message }}
  </info>
}
@for (
  item of beneficiaryClauseBeneficiaireForm.controls;
  track item;
  let i = $index
) {
  <div [formGroup]="item">
    <div class="row">
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-column label="Civilité" [derrors]="derrors">
          <mat-select formControlName="civility">
            @for (option of options; track option) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </pr-input-column>
      </div>
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-column label="Nom de naissance" [derrors]="derrors">
          <input formControlName="maidenName" type="text" />
        </pr-input-column>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-column label="Nom de famille" [derrors]="derrors">
          <input formControlName="lastName" type="text" />
        </pr-input-column>
      </div>
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-column label="Prénom" [derrors]="derrors">
          <input formControlName="firstName" type="text" />
        </pr-input-column>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-date
          label="Date de naissance"
          formControlName="birthDate"
          [derrors]="derrors"
          [isDefault]="false"
        ></pr-input-date>
      </div>
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-column label="Lieu de naissance" [derrors]="derrors">
          <input formControlName="birthPlace" type="text" />
        </pr-input-column>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-tel
          label="Téléphone"
          [derrors]="derrors"
          placeholder="Exemple : 0601010101"
          formControlName="phone"
          [isDefault]="false"
          type="text"
        >
        </pr-input-tel>
      </div>
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-percent
          label="Pourcentage"
          [derrors]="derrors"
          formControlName="percentage"
          [isProportion]="false"
          [allowDecimal]="false"
          [suffix]="'%'"
          [minValue]="0"
          [maxValue]="100"
        ></pr-input-percent>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-12">
        <pr-input-column label="Email" [derrors]="derrors">
          <input formControlName="email" type="text" />
          <i>
            <pr-icon name="email"></pr-icon>
          </i>
        </pr-input-column>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-12">
        <pr-input-maps
          label="Adresse"
          formGroupName="address"
          [isGMaps]="true"
          [countries]="countries"
          [derrors]="derrors"
          [isDefault]="false"
          [documentMapId]="'mapId' + i"
        >
        </pr-input-maps>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-3 align-self-center" style="margin-top: 2rem">
        @if (beneficiaryClauseBeneficiaireForm.length > 1) {
          <pr-button-confirm
            class="confirm"
            display="danger"
            clazz="pr-toolbar-button last"
            icon="delete_outline"
            title="Suppression"
            comment="Toute suppression est définitve, les données seront perdues."
            labelConfirm="Supprimer"
            labelCancel="Annuler"
            (onConfirm)="deleteFields(i)"
          >
            Êtes-vous sûr(e) de vouloir supprimer
          </pr-button-confirm>
        }
      </div>
    </div>
  </div>
}

<div class="row">
  <div class="col col-md-4">
    <pr-button-add
      type="button"
      display="neutral"
      (click)="addFields()"
      label="Ajouter un bénéficiaire"
      rightIcon="+"
    >
    </pr-button-add>
  </div>
</div>
